import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './CustomTilePopup.css';

const CustomTilePopup = ({ onClose, children }) => {
  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="tiles-container">
          <button onClick={onClose} className="close-button">
            <FontAwesomeIcon icon={faTimes} />
          </button>
          {children}
        </div>
      </div>
    </div>
  );
};

export default CustomTilePopup;
